import { nbNO } from './nb-NO';
import { daDK } from './da-DK';

import { getCountryCode } from '../../helpers';

export const getLanguageConfig = () => {
  return getCountryCode() === 'dk' ? daDK : nbNO;
};
